// extracted by mini-css-extract-plugin
export default {"form":"NewReport_form__r8oPt","input":"NewReport_input__5JFDB","impexp":"NewReport_impexp__pClMi"};